import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import {_imagenLogo} from '../imagenesBase64/logo'
import Swal from 'sweetalert2';
import {fechaActual} from '../Helpers/fechas';
import {formatearMontoMoneda} from '../Helpers/utilidades-globales'

pdfMake.vfs = pdfFonts.pdfMake.vfs;
export function ImprimirDetalleEgreso(datos, nombrePDF, tituloPDF,callbackMap,arrayCampos,orientacion,parametros){
    try{

        Swal.fire({
            html: 'Buscando...',
            timer: 600,
            onBeforeOpen: () => {
                Swal.showLoading()
            },
        }).then(data=>{
            generarDocumento(datos, nombrePDF, tituloPDF,callbackMap,arrayCampos,orientacion ? orientacion : 'portrait',parametros)
        })
    }catch(err){

            const mensaje_html = `<p>Hubo un error al generar el documento</p><p>${err}</p>`

            Swal.fire({
                html:mensaje_html,
                icon: 'warning',
                confirmButtonColor: '#3085d6',
            })
        }
}

function createWritingArea(value, minimumLines = 1, lineHeight = 18) {
  const contentLines = String(value ?? '').split(/\r?\n/).filter((line) => line.trim() !== '');
  const totalLines = Math.max(minimumLines, contentLines.length || 1);

  return {
    table: {
      widths: ['*'],
      heights: () => lineHeight,
      body: Array.from({ length: totalLines }, (_, index) => ([{
        text: contentLines[index] || ' ',
        margin: [0, 0, 0, 4]
      }]))
    },
    layout: {
      hLineWidth: (index) => index === 0 ? 0 : 0.8,
      vLineWidth: () => 0,
      hLineColor: () => 'black',
      paddingLeft: () => 0,
      paddingRight: () => 0,
      paddingTop: () => 0,
      paddingBottom: () => 0,
    },
    margin: [0, 2, 0, 0]
  };
}

function createSignatureBlock(label) {
  return {
    stack: [
      {
        canvas: [
          { type: 'line', x1: 0, y1: 0, x2: 140, y2: 0, lineWidth: 1, lineColor: 'black' }
        ],
        margin: [0, 18, 0, 6]
      },
      {
        text: label,
        alignment: 'center',
        bold: true,
        fontSize: 10
      }
    ],
    border: [false, false, false, false]
  };
}

function generarDocumento(parametros, nombrePDF, tituloPDF, orientacion = 'portrait') {
  // helper para un layout con bordes siempre
  const boxedLayout = {
    hLineWidth: () => 1,
    vLineWidth: () => 1,
    hLineColor: () => 'black',
    vLineColor: () => 'black',
    paddingLeft: () => 5,
    paddingRight: () => 5,
    paddingTop: () => 3,
    paddingBottom: () => 3,
  };

  const content = [];

  // 1) Encabezado (logo + título)
  content.push({
    table: {
      widths: ['auto', '*'],
      body: [[
        { image: _imagenLogo, width: 50, border: [false, false, false, false] },
        {
          stack: [
            { text: 'Unión de las Asambleas de Dios', bold: true, fontSize: 14 },
            { text: 'Egreso', bold: true, fontSize: 15 }
          ],
          alignment: 'center',
          border: [false, false, false, false]
        }
      ]]
    },
    layout: 'noBorders',
    margin: [0, 0, 0, 10]
  });

  // 2) Sección Fecha y Comprobante
  content.push({
    table: {
      widths: ['50%', '50%'],
      body: [[
        {
          stack: [
            { text: 'Fecha', bold: true },
            createWritingArea(parametros.fecha)
          ]
        },
        {
          stack: [
            { text: 'Comprobante', bold: true },
            createWritingArea(getNComprobante(parametros))
          ]
        },
      ]]
    },
    layout: boxedLayout,
    margin: [0, 0, 0, 5]
  });

  // 4) Sección Proveedor
  content.push({
    table: {
      widths: ['*'],
      body: [[
        {
          stack: [
            { text: 'Proveedor', bold: true },
            createWritingArea(parametros.proveedor || '--')
          ]
        }
      ]]
    },
    layout: boxedLayout,
    margin: [0, 0, 0, 5]
  });

  // 5) Sección Descripción
  content.push({
    table: {
      widths: ['*'],
      body: [[
        {
          stack: [
            { text: 'Descripción', bold: true },
            createWritingArea(parametros.descripcion || '--', 2, 20)
          ]
        }
      ]]
    },
    layout: boxedLayout,
    margin: [0, 0, 0, 5]
  });

  // 6) Sección Caja y Rubro
  content.push({
    table: {
      widths: ['50%', '50%'],
      body: [[
        {
          stack: [
            { text: 'Caja', bold: true },
            createWritingArea(parametros?.caja ?? '--')
          ]
        },
        {
          stack: [
            { text: 'Rubro', bold: true },
            createWritingArea(parametros?.rubro ?? '--')
          ]
        }
      ]]
    },
    layout: boxedLayout,
    margin: [0, 0, 0, 5]
  });

  // 7) Sección Forma de Pago (bullets)
  content.push({
    table: {
      widths: ['*'],
      body: [[
        {
          stack: [
            { text: 'Forma de Pago', bold: true },
            {
              ul: parametros.formaPagos.map(fp => {
                if (!fp.tipo_movimiento) {
                  return `Efectivo – ${formatearMontoMoneda(fp.m_neto)}`;
                } else {
                  return `${fp.tipo_movimiento} – ${formatearMontoMoneda(fp.m_neto)} – Emisión: ${fp.f_emision ?? '--'} – Acreditación: ${fp.f_acreditacion ?? '--'} – Banco: ${fp.id_banco ?? '--'}`;
                }
              })
            }
          ]
        }
      ]]
    },
    layout: boxedLayout,
    margin: [0, 0, 0, 5]
  });

  // 8) Minuta
  content.push({
    table: {
      widths: ['*'],
      body: [[
        {
          stack: [
            { text: 'Minuta de asiento contable Nº:', bold: true },
            createWritingArea(' ', 1, 18),
            { text: 'Datos contables:', bold: true },
            createWritingArea(parametros.detalle || ' ', 4, 20)
          ]
        }
      ]]
    },
    layout: boxedLayout,
    margin: [0, 0, 0, 5]
  });

  // 9) Sección Tanda y Total
  content.push({
    table: {
      widths: ['50%', '50%'],
      body: [[
        {
          stack: [
            { text: 'Tanda', bold: true },
            createWritingArea(parametros?.tanda ?? '--')
          ]
        },
        {
          stack: [
            { text: 'Total', bold: true, fontSize: 12 },
            { text: parametros.moneda, bold: true, fontSize: 12 },
            { text: formatearMontoMoneda(parametros.monto), fontSize: 15, bold: true }
          ],
          alignment: 'right'
        }
      ]]
    },
    layout: boxedLayout,
    margin: [0, 0, 0, 10]
  });

  // 8) Firma y control (puedes replicar un row con tres celdas)
  content.push({
    table: {
      widths: ['33%', '33%', '33%'],
      body: [[
        createSignatureBlock('CONFECCIONADO POR'),
        createSignatureBlock('TESORERÍA'),
        createSignatureBlock('CONTABLE')
      ]]
    },
    layout: 'noBorders',
    margin: [0, 20, 0, 0]
  });

  const docDefinition = {
    pageOrientation: orientacion,
    pageMargins: [40, 80, 40, 40],
    header: (currentPage, pageCount, pageSize) => {
      if (currentPage > 1) {
        return {
          text: tituloPDF,
          alignment: 'center',
          margin: [0, 20, 0, 10]
        };
      }
    },
    footer: (currentPage, pageCount) => ({
      columns: [
        { text: fechaActual('DD/MM/YYYY'), alignment: 'left', margin: [40, 0] },
        { text: `Página ${currentPage} de ${pageCount}`, alignment: 'right', margin: [0, 0, 40, 0] }
      ],
      fontSize: 8
    }),
    content
  };

  // Enviar directo al diálogo de impresión (antes descargaba el PDF, lo que agregaba un paso extra).
  // Si el navegador bloquea la ventana emergente, se cae de nuevo a la descarga.
  const pdf = pdfMake.createPdf(docDefinition);
  const nombreArchivo = nombrePDF ? `detalle-egreso-${nombrePDF}.pdf` : 'detalle-egreso.pdf';

  try {
    pdf.print({}, window.open('', '_blank'));
  } catch (err) {
    console.log('No se pudo abrir el diálogo de impresión, se descarga el PDF', err);
    pdf.download(nombreArchivo);
  }
}

function getNComprobante(datos) {
  if (datos.comprobante_egreso && !datos.nro_comprobante) {
    return datos.comprobante_egreso;
  } else if (!datos.comprobante_egreso && datos.nro_comprobante) {
    return datos.nro_comprobante;
  } else if (datos.comprobante_egreso && datos.nro_comprobante) {
    return `${datos.comprobante_egreso} - ${datos.nro_comprobante}`;
  } else return '--';
} 

